export default __webpack_public_path__ + "static/media/cropped-favicon-192x192.37891ff2.png";